module.exports = __webpack_public_path__ + "img/dialog-pic@2x.1b2c3ee0.png";